import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'

/**
 * Statut d'un compte, en clair : liste des utilisateurs, fiche apprenant (#242) et
 * membres d'une organisation. Jamais la constante machine (`PENDING_ACTIVATION`)
 * sous les yeux d'un utilisateur.
 */
export function AccountStatusBadge({ status }: { status: string }) {
  const { t } = useTranslation()
  switch (status) {
    case 'ENABLED':
      return <Badge variant="success">{t('status.active')}</Badge>
    case 'PENDING_ACTIVATION':
      return <Badge variant="warning">{t('status.pending')}</Badge>
    default:
      return <Badge variant="secondary">{t('status.disabled')}</Badge>
  }
}
